import { createSelector } from "reselect";
import { adminSectionSelector } from "../admin_section_selector";

/**
 * Selector to select the selected User Table Page Number
 */

export const selectedUserTablePageNumberSelector = createSelector(
  adminSectionSelector,
  adminSection => {
    return adminSection.selectedUserTablePageNumber;
  }
);
